var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        "align-v": "end",
                        offset: "0",
                        "offset-lg": "6",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "apeironGwApp.opcionterminalSnp.acciones.buscar"
                          ),
                        },
                        on: {
                          keyup: function ($event) {
                            return _vm.buscarEnOpcionesTerminales()
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroOpcionesTerminales,
                          callback: function ($$v) {
                            _vm.filtroOpcionesTerminales = $$v
                          },
                          expression: "filtroOpcionesTerminales",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          bordered: "",
                          small: "",
                          "thead-class": "custom-header",
                          items: _vm.opcionesTerminalesFiltradas,
                          fields: _vm.fieldsOpcionesTerminales,
                          "show-empty": "",
                          "empty-text": _vm.$t(
                            "apeironGwApp.opcionterminalSnp.tabla.empty"
                          ),
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(instituciones)",
                            fn: function (data) {
                              return _vm._l(
                                data.item.instituciones,
                                function (institucion) {
                                  return _c(
                                    "b-row",
                                    {
                                      key:
                                        institucion.claveInstitucion +
                                        institucion.claveSede,
                                    },
                                    [
                                      _c("b-col", { staticClass: "m-2" }, [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              institucion.nombre
                                            ),
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              )
                            },
                          },
                          {
                            key: "cell(acciones)",
                            fn: function (data) {
                              return [
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.opcionterminalSnp.acciones.editar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.opcionterminalSnp.acciones.editar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editarOpcionTerminal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "pencil",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.opcionterminalSnp.acciones.eliminar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.opcionterminalSnp.acciones.eliminar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.mostrarModalEliminarOpcionTerminal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "trash",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.registros,
                          "per-page": _vm.perPage,
                          "aria-controls": "my-table",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.esEscritura
                ? _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.opcionterminalSnp.mensajes.guardarSeccion",
                                      {
                                        guardarSeccion: _vm
                                          .$t(
                                            "apeironGwApp.opcionterminalSnp.acciones.guardarSeccion"
                                          )
                                          .toString(),
                                      }
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-2",
                          staticStyle: { "text-align": "end" },
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                block: "",
                                variant: "primary",
                                disabled: !_vm.esEscritura,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.guardarOpcionesTerminales()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.opcionterminalSnp.acciones.guardarSeccion"
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "save" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { id: "modal-eliminar", size: "md" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.opcionterminalSnp.modal.tituloEliminar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.esEscritura,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.eliminarOpcionTerminal()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.opcionterminalSnp.acciones.eliminar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalEliminar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.opcionterminalSnp.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalEliminar,
                            callback: function ($$v) {
                              _vm.mostrarModalEliminar = $$v
                            },
                            expression: "mostrarModalEliminar",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("div", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.opcionterminalSnp.modal.detalleEliminar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }